import { render, staticRenderFns } from "./marredflow.vue?vue&type=template&id=32f6d5bc&scoped=true&lang=pug&"
import script from "./marredflow.vue?vue&type=script&lang=js&"
export * from "./marredflow.vue?vue&type=script&lang=js&"
import style0 from "./marredflow.vue?vue&type=style&index=0&id=32f6d5bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6d5bc",
  null
  
)

export default component.exports